export const environment = {
  production: false,
  urlSignalRHub: 'https://api-vinculacion-lab.agaval.com/VinculacionHub',
  pagoVinculacionEndPoint: 'https://apis.agaval.com/vinculacion-lab/api/',
  urlCompras: 'https://tucreditolab.agaval.com/',
  urlVinculacion: 'https://solicitudlab.agaval.com/?centroCosto=cc&validacionIdentidad=vi',
  storage: 'https://agavalceibadiag.blob.core.windows.net',
  clienteIp: 'https://api.ipify.org/?format=json',
  apmServerUrl: 'https://rum-lab.agaval.com/rum-apm/'
};
